import React from "react";

// ASSETS
import Illustration from "assets/icons/Deco corner homepage _ About Board DSU_.svg";

// STYLES
import {
  CardContainer,
  CardContent,
  CardIllustration,
  CardImage,
  TitleRow,
  MailLink,
} from "./CivicDialoguePageCustomCardStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { CardProps } from "./CivicDialoguePageCustomCardModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const CivicDialoguePageCustomCard: React.FC<CardProps> = ({
  type,
  content,
  colSpan,
  rowSpan,
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <CardContainer
      colSpan={colSpan}
      rowSpan={rowSpan}
      style={{ padding: type === "image" ? 0 : undefined }}
    >
      {type === "image" && <CardImage src={content} alt="Card image" />}

      {type === "paragraph" && <CardIllustration src={Illustration} alt="" />}

      {(type === "content" || type === "paragraph") && (
        <CardContent type={type}>
          {type === "content" && (
            <TitleRow>
              <CustomText
                text={t("view.internship.title")}
                type={TextType.H3}
                color={COLORS.Cultured}
              />
            </TitleRow>
          )}

          <CustomText
            text={t(content.paragraph)}
            type={TextType.P1}
            color="#E6E7EB"
          />

          {content.paragraph2 && (
            <MailLink
              biggerCursor={biggerCursor}
              onClick={() =>
                (window.location.href = `mailto:rezilienta.dgpc@mai.gov.ro`)
              }
            >
              {t(content.paragraph2)}
            </MailLink>
          )}

          {content.paragraph3 && (
            <CustomText
              text={t(content.paragraph3)}
              type={TextType.P1}
              color="#E6E7EB"
            />
          )}
        </CardContent>
      )}
    </CardContainer>
  );
};

export default CivicDialoguePageCustomCard;
